import styled from 'styled-components'

export const Box = styled.div`
	float: left;
	width: 100%;
	color: #A9A9A9;
	margin-top: 30px;
`

export const PrecoDe = styled.span`
	float: left;
	width: 100%;
	color: #fff;
	font-size: 13px;
	text-decoration: line-through;
`

export const PrecoPor = styled.span`
	float: left;
	width: 100%;
	color: #fff;
	font-size: 22px;
	margin: 7px 0;
	font-weight: bold;
`

export const Link = styled.a`
	float: left;
	background-color: #FF6464;
	border: 0;
	width: 90%;
	border-radius: 3px;
	padding: 0 15px;
	height: 58px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 10px;

	span {
		color: #fff;
		font-size: 14px;
		flex: 1;
		font-weight: bold;
	}

	@media only screen and (max-width: 1000px) {
		width: 100%;
	}
`
